import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { LoaderService } from './shared/loader.service';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { tenantInterceptor } from './modules/base/interceptor/tenant.interceptor';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { NgxsModule, Store } from '@ngxs/store';
import { OrderPortalGlobalState } from './shared/state/order-portal-global.state';
import { NavigationActionTiming, NgxsRouterPluginModule } from '@ngxs/router-plugin';
import { NgxsStoragePluginModule, StorageOption } from '@ngxs/storage-plugin';
export const appConfig: ApplicationConfig = {
  providers: [provideRouter(routes),
    importProvidersFrom([
      NgxsModule.forRoot([], {
        developmentMode: true,
      }),
      NgxsStoragePluginModule.forRoot({
        storage: StorageOption.LocalStorage,
        key: [OrderPortalGlobalState],
      }),
      NgxsRouterPluginModule.forRoot({
        navigationActionTiming: NavigationActionTiming.PostActivation,
      }),
    ]),
    provideAnimations(),
    LoaderService,
    MessageService,
    ToastModule,
    provideHttpClient(withInterceptors([tenantInterceptor]))
  ]
};
